import { memo } from 'react';
import { Button } from 'react-bootstrap';

/**
 * The 1m / 10m / 30m / 1h resolution picker that sits in a chart card's header.
 *
 * It used to be a single ButtonGroup of four default-sized buttons in a row.
 * Next to a title like "E75 EXTRUDER YIELD  E75 COLOR YIELD" that row had
 * nowhere to go and pushed itself out of the card. Two by two takes half the
 * width and the same height as the two-line titles it sits beside.
 *
 * Written once and shared: five chart components had their own copy of the four
 * buttons, the handler and the styles.
 */

const BUCKETS = [
  { label: '1m', bucket: 'machine_data_minute' },
  { label: '10m', bucket: 'machine_data_10minute' },
  { label: '30m', bucket: 'machine_data_30minute' },
  { label: '1h', bucket: 'machine_data_hour' },
];

const BucketRangeButtons = ({ current, onChange }) => (
  <div style={styles.grid}>
    {BUCKETS.map(({ label, bucket }) => (
      <Button
        key={bucket}
        size="sm"
        variant={current === bucket ? 'primary' : 'phoenix-secondary'}
        onClick={() => onChange(bucket)}
        style={styles.button}
      >
        {label}
      </Button>
    ))}
  </div>
);

const styles = {
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '3px',
    // keeps the picker off the title even when the card is narrow
    flex: '0 0 auto',
    width: '76px',
  },
  button: {
    padding: '1px 0',
    fontSize: '11px',
    lineHeight: 1.5,
    minWidth: 0,
  },
};

export default memo(BucketRangeButtons);
